import { Box, SkeletonLine, Text } from '@wix/design-system';
import React from 'react';
import { useSharedAltTextScreenContext } from '../../context';
import { AltTextImageThumbnail, AltTextImageThumbnailWithEnlarge } from './alt-text-image-thumbnail';
export const AltTextImageItemHeader = _ref => {
  let {
    imageUrl,
    altText,
    isDecorative,
    isLinked = false,
    isOpen,
    isLoading = false,
    // TODO: replace hardcoded defaults with t() when translation keys PR is merged
    placeholderText = 'Add alt text',
    decorativeText = 'Decorative image',
    imageSize = 32,
    showEnlargeButton = false,
    onEnlargeClick,
    isImageEnlarged = false
  } = _ref;
  const {
    translations
  } = useSharedAltTextScreenContext();
  const enlargeButtonTooltip = translations.imageItem.enlargeButtonTooltip;
  const passesAsDecorative = isDecorative && !isLinked;
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    dataHook: "alt-text-item-header-container",
    direction: "horizontal",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0
  }, isOpen && showEnlargeButton ? /*#__PURE__*/React.createElement(AltTextImageThumbnailWithEnlarge, {
    enlargeButtonTooltip: enlargeButtonTooltip,
    imageSize: imageSize,
    imageUrl: imageUrl,
    isImageEnlarged: isImageEnlarged,
    onEnlargeClick: onEnlargeClick
  }) : /*#__PURE__*/React.createElement(AltTextImageThumbnail, {
    imageSize: imageSize,
    imageUrl: imageUrl
  })), !isOpen && /*#__PURE__*/React.createElement(Box, {
    overflow: "hidden",
    paddingLeft: "SP3",
    verticalAlign: "middle"
  }, isLoading ? /*#__PURE__*/React.createElement(SkeletonLine, {
    width: "160px"
  }) : passesAsDecorative || altText ? /*#__PURE__*/React.createElement(Text, {
    dataHook: "alt-text-item-header-text",
    maxLines: 2,
    size: "tiny",
    weight: "normal",
    ellipsis: true,
    secondary: true
  }, passesAsDecorative ? decorativeText : altText) : /*#__PURE__*/React.createElement(Text, {
    dataHook: "alt-text-item-header-placeholder",
    size: "tiny",
    ellipsis: true,
    light: true,
    secondary: true
  }, placeholderText)));
};
//# sourceMappingURL=alt-text-image-item-header.js.map